<template>
    <v-container fluid style="max-height: 90px; position: fixed; bottom: 0; overflow: hidden; user-select: none;" pa-0>
        <v-row justify="space-between" align="center" class="flex-nowrap" no-gutters style="max-height: 90px;">
<!--            <img src="@/assets/bottom_bar.svg"-->
<!--                 alt=""-->
<!--                 style="width: 100%; height: 90px; position: absolute; bottom: 0; left: 0;"-->
<!--            >-->
            <div style="width: 100%; height: 90px; position: absolute; bottom: 0; background-color: rgba(255, 255, 255, 0.1)"></div>
            <v-col cols="auto" justify-self="start">
                <v-row justify="center" align="start" class="flex-nowrap" no-gutters v-if="isAuthenticated">
                    <v-col cols="auto">
                        <journey-control></journey-control>
                    </v-col>
                    <v-col cols="auto" class="mx-5">
                        <survey-progress></survey-progress>
                    </v-col>
                    <v-col cols="auto" align-self="center">
                        <journey-plan></journey-plan>
                    </v-col>
                </v-row>
            </v-col>
          <transition name="fade">
            <v-col cols="auto" justify-self="center" v-if="mediaIsActive" class="flex-grow-1">
                  <media-controls v-demo-show="{event:'welcome.mediacontrols', show:mediaIsActive}" id="mediacontrols"></media-controls>
            </v-col>
          </transition>
            <v-col cols="auto" justify-self="end">
                <v-row justify="center" align="center" class="flex-nowrap" no-gutters>
<!--                    <v-col cols="auto">-->
<!--                       <v-btn icon @click="help()">-->
<!--                           <v-icon>mdi-help-circle</v-icon>-->
<!--                       </v-btn>-->
<!--                    </v-col>-->
                    <v-col cols="auto">
                        <time-remaining></time-remaining>
                    </v-col>
                    <v-col cols="auto" class="mx-2">
                        <settings v-demo-show="{event:'welcome.settings', show:true}"></settings>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import MediaControls from "./bottom/MediaControls";
    import JourneyControl from "./bottom/JourneyControl";
    import SurveyProgress from "./bottom/SurveyProgress";
    import JourneyPlan from "./bottom/JourneyPlan";
    import TimeRemaining from "./bottom/TimeRemaining";
    import Settings from "./bottom/Settings";

    export default {
        name: "SystemFooter",
        computed: {
            mediaIsActive() {
                return this.$store.state.media.visible;
            },
            isAuthenticated(){
              return !!this.$store.state.auth.authToken;
            }
        },
        components: {
            MediaControls,
            JourneyControl,
            SurveyProgress,
            JourneyPlan,
            TimeRemaining,
            Settings
        },
        mounted(){

        },
        methods: {
            help(){

            }
        }
    }
</script>

<style scoped>

</style>
